module.exports = __webpack_public_path__ + "img/event-img-3.751a7e25.jpg";